import React from 'react';
import { Grid, Typography, Container, Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button } from '@material-ui/core';
import Layout from './Layout';
import CustomBreadcrumbs from './Breadcrumb';

const Support = () => {
    const breadcrumbsLinks = [
        { label: 'Home', href: '/' }
    ];

    // Sample data for the table
    const contactDetails = [
        { name: 'Vishwanath Rao', phone: '9033091070', email: 'vishwanath.rao@tatamotors.com' }
    ];

    const pdfUrl = "/user-manual.pdf";

    return (
        <Layout>
            <Container>
                <Box mt={1} mb={3}>
                    <CustomBreadcrumbs links={breadcrumbsLinks} current="Support" />
                </Box>
                <Box mb={6}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={12}>
                            <Typography variant="h6" gutterBottom>
                                Support TML SPOC
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <TableContainer component={Paper}>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Name</TableCell>
                                            <TableCell>Phone</TableCell>
                                            <TableCell>Email</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {contactDetails.map((contact, index) => (
                                            <TableRow key={index}>
                                                <TableCell>{contact.name}</TableCell>
                                                <TableCell>{contact.phone}</TableCell>
                                                <TableCell>{contact.email}</TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>
                    </Grid>
                    {/* ✅ User Manual Section */}
                    <Grid item xs={12}>
                        <Box mt={6}>
                            <Typography variant="h6" gutterBottom>
                                User Manual
                            </Typography>

                            <Grid container spacing={2}>
                                <Grid item xs={8} sm="auto">
                                    <Button
                                        fullWidth
                                        variant="contained"
                                        color="primary"
                                        onClick={() => window.open(pdfUrl, "_blank")}
                                    >
                                        View Manual
                                    </Button>
                                </Grid>

                                <Grid item xs={8} sm="auto">
                                    <Button
                                        fullWidth
                                        variant="outlined"
                                        color="primary"
                                        component="a"
                                        href={pdfUrl}
                                        download="User_Manual.pdf"
                                    >
                                        Download Manual
                                    </Button>
                                </Grid>
                            </Grid>
                        </Box>
                    </Grid>


                </Box>
            </Container>
        </Layout>
    );
};

export default Support;

